module.exports = __webpack_public_path__ + "img/cover-duncan.75171c27.png";